var map = {
	"./": [
		"El06"
	],
	"./2fa": [
		"Zd3P",
		41
	],
	"./2fa.vue": [
		"Zd3P",
		41
	],
	"./404": [
		"61Jn",
		0,
		42
	],
	"./404.vue": [
		"61Jn",
		0,
		42
	],
	"./503": [
		"hqv2",
		0,
		43
	],
	"./503.vue": [
		"hqv2",
		0,
		43
	],
	"./admin/accounts": [
		"UHHI",
		0,
		1,
		14
	],
	"./admin/accounts/": [
		"UHHI",
		0,
		1,
		14
	],
	"./admin/accounts/components/Filters/FilterByActivityUser": [
		"WMds",
		44
	],
	"./admin/accounts/components/Filters/FilterByActivityUser.vue": [
		"WMds",
		44
	],
	"./admin/accounts/components/Filters/FilterByTransaction": [
		"b3+2",
		45
	],
	"./admin/accounts/components/Filters/FilterByTransaction.vue": [
		"b3+2",
		45
	],
	"./admin/accounts/components/Filters/FilterByTransactionType": [
		"EhZu",
		46
	],
	"./admin/accounts/components/Filters/FilterByTransactionType.vue": [
		"EhZu",
		46
	],
	"./admin/accounts/credit": [
		"RXGr",
		0,
		1,
		47
	],
	"./admin/accounts/credit.vue": [
		"RXGr",
		0,
		1,
		47
	],
	"./admin/accounts/debit": [
		"qTYK",
		0,
		1,
		48
	],
	"./admin/accounts/debit.vue": [
		"qTYK",
		0,
		1,
		48
	],
	"./admin/accounts/index": [
		"UHHI",
		0,
		1,
		14
	],
	"./admin/accounts/index.vue": [
		"UHHI",
		0,
		1,
		14
	],
	"./admin/accounts/show": [
		"Xwb5",
		0,
		1,
		49
	],
	"./admin/accounts/show.vue": [
		"Xwb5",
		0,
		1,
		49
	],
	"./admin/accounts/transactions": [
		"9oke",
		0,
		1,
		50
	],
	"./admin/accounts/transactions.vue": [
		"9oke",
		0,
		1,
		50
	],
	"./admin/add-ons": [
		"cx4U",
		15
	],
	"./admin/add-ons/": [
		"cx4U",
		15
	],
	"./admin/add-ons/changelog": [
		"A/ri",
		51
	],
	"./admin/add-ons/changelog.vue": [
		"A/ri",
		51
	],
	"./admin/add-ons/index": [
		"cx4U",
		15
	],
	"./admin/add-ons/index.vue": [
		"cx4U",
		15
	],
	"./admin/add-ons/install": [
		"VCNO",
		52
	],
	"./admin/add-ons/install.vue": [
		"VCNO",
		52
	],
	"./admin/affiliate": [
		"krLF",
		0,
		16
	],
	"./admin/affiliate/": [
		"krLF",
		0,
		16
	],
	"./admin/affiliate/commissions": [
		"XpSl",
		0,
		1,
		17
	],
	"./admin/affiliate/commissions/": [
		"XpSl",
		0,
		1,
		17
	],
	"./admin/affiliate/commissions/approve": [
		"uAtK",
		1,
		53
	],
	"./admin/affiliate/commissions/approve.vue": [
		"uAtK",
		1,
		53
	],
	"./admin/affiliate/commissions/index": [
		"XpSl",
		0,
		1,
		17
	],
	"./admin/affiliate/commissions/index.vue": [
		"XpSl",
		0,
		1,
		17
	],
	"./admin/affiliate/commissions/reject": [
		"N4z+",
		1,
		54
	],
	"./admin/affiliate/commissions/reject.vue": [
		"N4z+",
		1,
		54
	],
	"./admin/affiliate/commissions/show": [
		"vpHb",
		0,
		1,
		55
	],
	"./admin/affiliate/commissions/show.vue": [
		"vpHb",
		0,
		1,
		55
	],
	"./admin/affiliate/index": [
		"krLF",
		0,
		16
	],
	"./admin/affiliate/index.vue": [
		"krLF",
		0,
		16
	],
	"./admin/affiliate/tree": [
		"Fk7G",
		0,
		1,
		18
	],
	"./admin/affiliate/tree/": [
		"Fk7G",
		0,
		1,
		18
	],
	"./admin/affiliate/tree/index": [
		"Fk7G",
		0,
		1,
		18
	],
	"./admin/affiliate/tree/index.vue": [
		"Fk7G",
		0,
		1,
		18
	],
	"./admin/chat": [
		"acVr",
		0,
		19
	],
	"./admin/chat/": [
		"acVr",
		0,
		19
	],
	"./admin/chat/index": [
		"acVr",
		0,
		19
	],
	"./admin/chat/index.vue": [
		"acVr",
		0,
		19
	],
	"./admin/chat/messages": [
		"Cqzs",
		0,
		1,
		20
	],
	"./admin/chat/messages/": [
		"Cqzs",
		0,
		1,
		20
	],
	"./admin/chat/messages/delete": [
		"glmq",
		1,
		56
	],
	"./admin/chat/messages/delete.vue": [
		"glmq",
		1,
		56
	],
	"./admin/chat/messages/index": [
		"Cqzs",
		0,
		1,
		20
	],
	"./admin/chat/messages/index.vue": [
		"Cqzs",
		0,
		1,
		20
	],
	"./admin/chat/rooms": [
		"cwQy",
		0,
		1,
		21
	],
	"./admin/chat/rooms/": [
		"cwQy",
		0,
		1,
		21
	],
	"./admin/chat/rooms/create": [
		"nhfH",
		1,
		57
	],
	"./admin/chat/rooms/create.vue": [
		"nhfH",
		1,
		57
	],
	"./admin/chat/rooms/delete": [
		"eYPE",
		1,
		58
	],
	"./admin/chat/rooms/delete.vue": [
		"eYPE",
		1,
		58
	],
	"./admin/chat/rooms/edit": [
		"YPYs",
		1,
		59
	],
	"./admin/chat/rooms/edit.vue": [
		"YPYs",
		1,
		59
	],
	"./admin/chat/rooms/index": [
		"cwQy",
		0,
		1,
		21
	],
	"./admin/chat/rooms/index.vue": [
		"cwQy",
		0,
		1,
		21
	],
	"./admin/dashboard": [
		"lsD0",
		0,
		22
	],
	"./admin/dashboard/": [
		"lsD0",
		0,
		22
	],
	"./admin/dashboard/affiliates": [
		"Fu0c",
		0,
		1,
		2,
		60
	],
	"./admin/dashboard/affiliates.vue": [
		"Fu0c",
		0,
		1,
		2,
		60
	],
	"./admin/dashboard/games": [
		"fFsE",
		0,
		1,
		2,
		61
	],
	"./admin/dashboard/games.vue": [
		"fFsE",
		0,
		1,
		2,
		61
	],
	"./admin/dashboard/index": [
		"lsD0",
		0,
		22
	],
	"./admin/dashboard/index.vue": [
		"lsD0",
		0,
		22
	],
	"./admin/dashboard/users": [
		"408T",
		0,
		1,
		2,
		62
	],
	"./admin/dashboard/users.vue": [
		"408T",
		0,
		1,
		2,
		62
	],
	"./admin/games": [
		"pabe",
		0,
		1,
		23
	],
	"./admin/games/": [
		"pabe",
		0,
		1,
		23
	],
	"./admin/games/details": [
		"/gGd",
		1,
		63
	],
	"./admin/games/details.vue": [
		"/gGd",
		1,
		63
	],
	"./admin/games/index": [
		"pabe",
		0,
		1,
		23
	],
	"./admin/games/index.vue": [
		"pabe",
		0,
		1,
		23
	],
	"./admin/games/show": [
		"Ji66",
		0,
		1,
		64
	],
	"./admin/games/show.vue": [
		"Ji66",
		0,
		1,
		64
	],
	"./admin/generic-transactions": [
		"cReq",
		0,
		1,
		24
	],
	"./admin/generic-transactions/": [
		"cReq",
		0,
		1,
		24
	],
	"./admin/generic-transactions/dashboard": [
		"rkTA",
		0,
		1,
		65
	],
	"./admin/generic-transactions/dashboard.vue": [
		"rkTA",
		0,
		1,
		65
	],
	"./admin/generic-transactions/index": [
		"cReq",
		0,
		1,
		24
	],
	"./admin/generic-transactions/index.vue": [
		"cReq",
		0,
		1,
		24
	],
	"./admin/license": [
		"InnW",
		25
	],
	"./admin/license/": [
		"InnW",
		25
	],
	"./admin/license/index": [
		"InnW",
		25
	],
	"./admin/license/index.vue": [
		"InnW",
		25
	],
	"./admin/maintenance": [
		"ZrHZ",
		26
	],
	"./admin/maintenance/": [
		"ZrHZ",
		26
	],
	"./admin/maintenance/index": [
		"ZrHZ",
		26
	],
	"./admin/maintenance/index.vue": [
		"ZrHZ",
		26
	],
	"./admin/manual-transactions/manual-transactions": [
		"rZgg",
		0,
		1,
		66
	],
	"./admin/manual-transactions/manual-transactions.vue": [
		"rZgg",
		0,
		1,
		66
	],
	"./admin/my-dashboard": [
		"PfKk",
		0,
		27
	],
	"./admin/my-dashboard/": [
		"PfKk",
		0,
		27
	],
	"./admin/my-dashboard/general": [
		"p6CP",
		0,
		1,
		67
	],
	"./admin/my-dashboard/general.vue": [
		"p6CP",
		0,
		1,
		67
	],
	"./admin/my-dashboard/global": [
		"wr2s",
		0,
		1,
		7,
		40,
		68
	],
	"./admin/my-dashboard/global.vue": [
		"wr2s",
		0,
		1,
		7,
		40,
		68
	],
	"./admin/my-dashboard/index": [
		"PfKk",
		0,
		27
	],
	"./admin/my-dashboard/index.vue": [
		"PfKk",
		0,
		27
	],
	"./admin/reports": [
		"JqIJ",
		0,
		28
	],
	"./admin/reports/": [
		"JqIJ",
		0,
		28
	],
	"./admin/reports/daily-report": [
		"0xf1",
		0,
		69
	],
	"./admin/reports/daily-report.vue": [
		"0xf1",
		0,
		69
	],
	"./admin/reports/index": [
		"JqIJ",
		0,
		28
	],
	"./admin/reports/index.vue": [
		"JqIJ",
		0,
		28
	],
	"./admin/reports/weekly-report": [
		"g+oT",
		70
	],
	"./admin/reports/weekly-report.vue": [
		"g+oT",
		70
	],
	"./admin/sellers": [
		"rtMj",
		0,
		1,
		29
	],
	"./admin/sellers/": [
		"rtMj",
		0,
		1,
		29
	],
	"./admin/sellers/create": [
		"6fkr",
		1,
		71
	],
	"./admin/sellers/create.vue": [
		"6fkr",
		1,
		71
	],
	"./admin/sellers/dashboard": [
		"5r7S",
		0,
		1,
		72
	],
	"./admin/sellers/dashboard.vue": [
		"5r7S",
		0,
		1,
		72
	],
	"./admin/sellers/delete": [
		"im8K",
		1,
		73
	],
	"./admin/sellers/delete.vue": [
		"im8K",
		1,
		73
	],
	"./admin/sellers/edit": [
		"Qc8K",
		1,
		74
	],
	"./admin/sellers/edit.vue": [
		"Qc8K",
		1,
		74
	],
	"./admin/sellers/index": [
		"rtMj",
		0,
		1,
		29
	],
	"./admin/sellers/index.vue": [
		"rtMj",
		0,
		1,
		29
	],
	"./admin/sellers/mail": [
		"6nmI",
		0,
		1,
		75
	],
	"./admin/sellers/mail.vue": [
		"6nmI",
		0,
		1,
		75
	],
	"./admin/sellers/show": [
		"eNMQ",
		0,
		1,
		76
	],
	"./admin/sellers/show.vue": [
		"eNMQ",
		0,
		1,
		76
	],
	"./admin/settings": [
		"IKsI",
		0,
		1,
		30
	],
	"./admin/settings/": [
		"IKsI",
		0,
		1,
		30
	],
	"./admin/settings/index": [
		"IKsI",
		0,
		1,
		30
	],
	"./admin/settings/index.vue": [
		"IKsI",
		0,
		1,
		30
	],
	"./admin/settings/user-commissions": [
		"SuT/",
		0,
		77
	],
	"./admin/settings/user-commissions.vue": [
		"SuT/",
		0,
		77
	],
	"./admin/sites/sites": [
		"y0/y",
		0,
		13,
		78
	],
	"./admin/sites/sites.vue": [
		"y0/y",
		0,
		13,
		78
	],
	"./admin/supervisors": [
		"L27U",
		0,
		1,
		31
	],
	"./admin/supervisors/": [
		"L27U",
		0,
		1,
		31
	],
	"./admin/supervisors/create": [
		"Bxis",
		1,
		79
	],
	"./admin/supervisors/create.vue": [
		"Bxis",
		1,
		79
	],
	"./admin/supervisors/dashboard": [
		"JHui",
		0,
		1,
		80
	],
	"./admin/supervisors/dashboard.vue": [
		"JHui",
		0,
		1,
		80
	],
	"./admin/supervisors/delete": [
		"J/Fc",
		1,
		81
	],
	"./admin/supervisors/delete.vue": [
		"J/Fc",
		1,
		81
	],
	"./admin/supervisors/edit": [
		"u3bF",
		1,
		82
	],
	"./admin/supervisors/edit.vue": [
		"u3bF",
		1,
		82
	],
	"./admin/supervisors/index": [
		"L27U",
		0,
		1,
		31
	],
	"./admin/supervisors/index.vue": [
		"L27U",
		0,
		1,
		31
	],
	"./admin/supervisors/mail": [
		"Msn/",
		0,
		1,
		83
	],
	"./admin/supervisors/mail.vue": [
		"Msn/",
		0,
		1,
		83
	],
	"./admin/supervisors/show": [
		"TCgB",
		0,
		1,
		84
	],
	"./admin/supervisors/show.vue": [
		"TCgB",
		0,
		1,
		84
	],
	"./admin/support-tickets": [
		"+6lQ",
		0,
		32
	],
	"./admin/support-tickets/": [
		"+6lQ",
		0,
		32
	],
	"./admin/support-tickets/index": [
		"+6lQ",
		0,
		32
	],
	"./admin/support-tickets/index.vue": [
		"+6lQ",
		0,
		32
	],
	"./admin/users": [
		"K3um",
		0,
		33
	],
	"./admin/users/": [
		"K3um",
		0,
		33
	],
	"./admin/users/activity-by-user": [
		"2T2A",
		0,
		1,
		85
	],
	"./admin/users/activity-by-user.vue": [
		"2T2A",
		0,
		1,
		85
	],
	"./admin/users/delete": [
		"wzax",
		1,
		86
	],
	"./admin/users/delete.vue": [
		"wzax",
		1,
		86
	],
	"./admin/users/edit": [
		"aa1X",
		0,
		1,
		87
	],
	"./admin/users/edit.vue": [
		"aa1X",
		0,
		1,
		87
	],
	"./admin/users/index": [
		"K3um",
		0,
		33
	],
	"./admin/users/index.vue": [
		"K3um",
		0,
		33
	],
	"./admin/users/mail": [
		"xlIg",
		0,
		1,
		88
	],
	"./admin/users/mail.vue": [
		"xlIg",
		0,
		1,
		88
	],
	"./admin/users/referrer": [
		"895P",
		0,
		1,
		89
	],
	"./admin/users/referrer.vue": [
		"895P",
		0,
		1,
		89
	],
	"./admin/users/report": [
		"7FJZ",
		0,
		1,
		90
	],
	"./admin/users/report.vue": [
		"7FJZ",
		0,
		1,
		90
	],
	"./admin/users/show": [
		"fi/a",
		0,
		1,
		91
	],
	"./admin/users/show.vue": [
		"fi/a",
		0,
		1,
		91
	],
	"./admin/users/user-activity": [
		"FqzW",
		0,
		1,
		92
	],
	"./admin/users/user-activity.vue": [
		"FqzW",
		0,
		1,
		92
	],
	"./admin/users/user-bank-transfer": [
		"mxTK",
		0,
		1,
		93
	],
	"./admin/users/user-bank-transfer.vue": [
		"mxTK",
		0,
		1,
		93
	],
	"./admin/users/user-list": [
		"IJfm",
		0,
		1,
		94
	],
	"./admin/users/user-list.vue": [
		"IJfm",
		0,
		1,
		94
	],
	"./admin/users/user-without-referrer-list": [
		"gENW",
		0,
		1,
		95
	],
	"./admin/users/user-without-referrer-list.vue": [
		"gENW",
		0,
		1,
		95
	],
	"./changelog": [
		"Y4uV",
		5,
		6,
		9,
		8,
		96
	],
	"./changelog.vue": [
		"Y4uV",
		5,
		6,
		9,
		8,
		96
	],
	"./contentful-page": [
		"APgu",
		5,
		6,
		9,
		8,
		97
	],
	"./contentful-page.vue": [
		"APgu",
		5,
		6,
		9,
		8,
		97
	],
	"./email": [
		"u96V",
		34
	],
	"./email/": [
		"u96V",
		34
	],
	"./email/index": [
		"u96V",
		34
	],
	"./email/index.vue": [
		"u96V",
		34
	],
	"./email/verify": [
		"+QwP",
		98
	],
	"./email/verify.vue": [
		"+QwP",
		98
	],
	"./games": [
		"GHN0",
		1,
		35
	],
	"./games/": [
		"GHN0",
		1,
		35
	],
	"./games/index": [
		"GHN0",
		1,
		35
	],
	"./games/index.vue": [
		"GHN0",
		1,
		35
	],
	"./history": [
		"EXMR",
		0,
		36
	],
	"./history/": [
		"EXMR",
		0,
		36
	],
	"./history/games/details": [
		"fuGX",
		1,
		99
	],
	"./history/games/details.vue": [
		"fuGX",
		1,
		99
	],
	"./history/games/show": [
		"pzXP",
		0,
		1,
		100
	],
	"./history/games/show.vue": [
		"pzXP",
		0,
		1,
		100
	],
	"./history/games/verify": [
		"IeE+",
		0,
		1,
		101
	],
	"./history/games/verify.vue": [
		"IeE+",
		0,
		1,
		101
	],
	"./history/index": [
		"EXMR",
		0,
		36
	],
	"./history/index.vue": [
		"EXMR",
		0,
		36
	],
	"./history/losses": [
		"PyDs",
		0,
		1,
		102
	],
	"./history/losses.vue": [
		"PyDs",
		0,
		1,
		102
	],
	"./history/recent": [
		"6qx0",
		0,
		1,
		103
	],
	"./history/recent.vue": [
		"6qx0",
		0,
		1,
		103
	],
	"./history/user": [
		"per0",
		0,
		1,
		104
	],
	"./history/user.vue": [
		"per0",
		0,
		1,
		104
	],
	"./history/wins": [
		"zlzn",
		0,
		1,
		105
	],
	"./history/wins.vue": [
		"zlzn",
		0,
		1,
		105
	],
	"./homepage-v2": [
		"H6ZA",
		1,
		106
	],
	"./homepage-v2.vue": [
		"H6ZA",
		1,
		106
	],
	"./index": [
		"El06"
	],
	"./index.vue": [
		"El06"
	],
	"./leaderboard": [
		"84n/",
		0,
		1,
		107
	],
	"./leaderboard.vue": [
		"84n/",
		0,
		1,
		107
	],
	"./login": [
		"PExn",
		0,
		1,
		10,
		108
	],
	"./login.vue": [
		"PExn",
		0,
		1,
		10,
		108
	],
	"./new-homepage": [
		"zSTv",
		0,
		1,
		5,
		6,
		109
	],
	"./new-homepage.vue": [
		"zSTv",
		0,
		1,
		5,
		6,
		109
	],
	"./offline": [
		"iVo0",
		0,
		110
	],
	"./offline.vue": [
		"iVo0",
		0,
		110
	],
	"./pages": [
		"SXoI",
		37
	],
	"./pages/": [
		"SXoI",
		37
	],
	"./pages/index": [
		"SXoI",
		37
	],
	"./pages/index.vue": [
		"SXoI",
		37
	],
	"./password/email": [
		"qpop",
		10,
		112
	],
	"./password/email.vue": [
		"qpop",
		10,
		112
	],
	"./password/reset": [
		"MvOg",
		113
	],
	"./password/reset.vue": [
		"MvOg",
		113
	],
	"./register": [
		"3OJL",
		0,
		1,
		10,
		114
	],
	"./register.vue": [
		"3OJL",
		0,
		1,
		10,
		114
	],
	"./support": [
		"MfFc",
		0,
		115
	],
	"./support.vue": [
		"MfFc",
		0,
		115
	],
	"./tutorial/tutorialsDetails": [
		"cdIE",
		5,
		6,
		9,
		8,
		116
	],
	"./tutorial/tutorialsDetails.vue": [
		"cdIE",
		5,
		6,
		9,
		8,
		116
	],
	"./tutorial/tutorialsList": [
		"y6LY",
		5,
		6,
		9,
		8,
		117
	],
	"./tutorial/tutorialsList.vue": [
		"y6LY",
		5,
		6,
		9,
		8,
		117
	],
	"./user/account/transactions": [
		"XSh/",
		0,
		1,
		118
	],
	"./user/account/transactions.vue": [
		"XSh/",
		0,
		1,
		118
	],
	"./user/affiliate": [
		"ggx2",
		0,
		38
	],
	"./user/affiliate/": [
		"ggx2",
		0,
		38
	],
	"./user/affiliate/commissions": [
		"2XLA",
		0,
		1,
		119
	],
	"./user/affiliate/commissions.vue": [
		"2XLA",
		0,
		1,
		119
	],
	"./user/affiliate/index": [
		"ggx2",
		0,
		38
	],
	"./user/affiliate/index.vue": [
		"ggx2",
		0,
		38
	],
	"./user/affiliate/info": [
		"EWL1",
		0,
		120
	],
	"./user/affiliate/info.vue": [
		"EWL1",
		0,
		120
	],
	"./user/affiliate/stats": [
		"1Tr/",
		0,
		121
	],
	"./user/affiliate/stats.vue": [
		"1Tr/",
		0,
		121
	],
	"./user/edit": [
		"iotO",
		1,
		122
	],
	"./user/edit.vue": [
		"iotO",
		1,
		122
	],
	"./user/security": [
		"/w8m",
		0,
		39
	],
	"./user/security/": [
		"/w8m",
		0,
		39
	],
	"./user/security/2fa": [
		"Uuwf",
		123
	],
	"./user/security/2fa.vue": [
		"Uuwf",
		123
	],
	"./user/security/index": [
		"/w8m",
		0,
		39
	],
	"./user/security/index.vue": [
		"/w8m",
		0,
		39
	],
	"./user/security/password": [
		"ihfo",
		124
	],
	"./user/security/password.vue": [
		"ihfo",
		124
	],
	"./users/show": [
		"jPiQ",
		125
	],
	"./users/show.vue": [
		"jPiQ",
		125
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "H11n";
module.exports = webpackAsyncContext;